import cx from 'classnames';
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';
import ReviewStatusLabel from '../ReviewStatusLabel';

const DENIAL_REASONS = {
    '1': 'Inappropriate Language',
    '2': 'Content not relevant to product',
    '3': 'Other'
};

const ReviewStatus = ( {status, deniedReasonId, otherDeniedReason, className} ) => {
    if ( status === 1 || status == null ) {
        return null;
    }

    const reviewStatusClasses = cx(
        'flex-1 p-4 rounded',
        {
            'bg-yellow-lighter': status === 0,
            'border border-solid border-fail': status === 2
        },
        className
    );
    const denialReasonClasses = 'text-sm leading-tight my-1';
    const hasReason = !isEmptyOrNil( deniedReasonId );
    const hasOtherReason = !isEmptyOrNil( otherDeniedReason );
    return (
        <div className={reviewStatusClasses} data-testid="test-reviewStatus">
            <ReviewStatusLabel status={status}/>
            {hasReason || hasOtherReason ?
                <div className="mt-3 leading-normal">
                    {hasReason ?
                        deniedReasonId.map(
                            id => <dd className={denialReasonClasses}>&ndash; {DENIAL_REASONS[id]}</dd> ) :
                        null}
                    {hasOtherReason ? <dd className={denialReasonClasses}>&ndash; {otherDeniedReason}</dd> : null}
                </div>
                : null
            }

        </div>
    );
};

export default ReviewStatus;